import { api } from './Api'

class OrganizatorService {
  getList() {
    return api.get('organizator/getList.php');
  }
}

export const organizatorService = new OrganizatorService();